module.exports = __webpack_public_path__ + "static/media/paga-rapido-logo.c4efe776.png";